import { logo } from './default'

export { logo }
